import { Outlet, createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/products')({
  component: ProductsLayout,
})

function ProductsLayout(): JSX.Element {
  return <Outlet />
}
